<template >
  <div class="mainbody">
    <div class="tableHead">
      <div class="box">
        <p class="title1">拥有积分校友</p>
        <p class="title2">{{ alumniIntegral }}位</p>
      </div>
      <div class="aLine"></div>
      <div class="box">
        <p class="title1">现有积分</p>
        <div>
          <span class="title2">{{ integralTotalAverage }}</span>
          <span class="title3">(平均)</span>
          <span class="title2">{{ integralTotalTotal }}</span>
          <span class="title3">(总计)</span>
        </div>
      </div>
      <div class="aLine"></div>
      <div class="box">
        <p class="title1">已兑换积分</p>
        <div>
          <span class="title2">{{ consumeTotalAverage }}</span>
          <span class="title3">(平均)</span>
          <span class="title2">{{ consumeTotalTotal }}</span>
          <span class="title3">(总计)</span>
          <span class="title2">{{ consumeTotal.count }}</span>
          <span class="title3">(次)</span>
        </div>
      </div>
    </div>
    <div class="tableInfo">
      <el-table :data="data_list" @row-click="toDetails">
        <el-table-column prop="student_no" label="学号" min-width="1"></el-table-column>
        <el-table-column prop="name_cn" label="姓名" min-width="2"></el-table-column>
        <el-table-column prop="integral" label="现有积分" min-width="1"></el-table-column>
        <el-table-column prop="consume" label="已兑换积分" min-width="1"></el-table-column>
        <el-table-column prop="consume_count" label="兑换次数" min-width="1"></el-table-column>
        <el-table-column prop="operating" label="操作" min-width="4" align="right">
          <template slot-scope="scope">
            <el-button class="operateText" size="mini" type="text" @click="toDetails(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :key="elementui_page_key"
        class="elPagination"
        background
        layout="prev, pager, next"
        :page-size="pageMaxSize"
        :page-count="pageCount"
        :current-page="currentPage"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import * as StrUtils from '@/utils/strUtils.js'
import * as Utils from '@/utils/utils.js'
import { URL_PATH, LIST_PAGE_MAX_SIZE } from '@/config/config'
import * as Constant from '@/utils/constant.js'
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'

export default {
  components: {},
  data() {
    return {
      urlPath: URL_PATH,
      data_list: [], //数据列表
      optionsExamine: Constant.options_examine,
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 1,
      alumniIntegral: 0,
      integralTotal: 0,
      integralTotalAverage: 0,
      integralTotalTotal: 0,
      consumeTotal: 0,
      consumeTotalAverage: 0,
      consumeTotalTotal: 0
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList: function () {
      this.$api
        .integralAlumniList({
          token: localStorage.getItem('token'),
          page: this.currentPage,
          limit: this.pageMaxSize
        })
        .then(({ data }) => {
          this.alumniIntegral = data.Data.alumniIntegral
          this.integralTotal = data.Data.integralTotal
          this.consumeTotal = data.Data.consumeTotal
          this.integralTotalAverage = StrUtils.getIntegralTotal(data.Data.integralTotal.average)
          this.integralTotalTotal = StrUtils.getIntegralTotal(data.Data.integralTotal.total)
          this.consumeTotalAverage = StrUtils.getIntegralTotal(data.Data.consumeTotal.average)
          this.consumeTotalTotal = StrUtils.getIntegralTotal(data.Data.consumeTotal.total)

          let current_page = Utils.listPage(data, this.currentPage)
          if (current_page) {
            this.currentPage = current_page
            this.getList()
          }
          this.pageCount = data.Data.pageCount
          this.data_list = data.Data.model
          this.data_list.forEach(info => {
            this.optionsExamine.forEach(examin => {
              if (info.result == parseInt(examin.value)) {
                info.result = examin.text
              }
            })
            info.createTime = Utils.dateFormat(info.create_time * 1000)
          })
        })
        .catch(({ error }) => {})
    },
    currentChange(val) {
      this.elementui_page_key++
      this.currentPage = val
      this.getList()
    },
    // 查看详情
    toDetails(row) {
      Api.verifyApi(CApi.api_getAisInfoById, verify => {
        if (verify) {
          this.meunItem = JSON.parse(localStorage.getItem('meunItem'))
          this.meunItem.userid = row.id
          localStorage.setItem('meunItem', JSON.stringify(this.meunItem))
          this.$router.push('/data/user-details')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.mainbody {
  // overflow: hidden;
  // background-color: #ffffff;
  border-radius: 5px;
  // padding-bottom: 58px;
}
.mainbody .tableHead {
  background-color: #ffffff;
  box-sizing: border-box;
  margin-bottom: 16px;
  overflow: hidden; /*溢出的部分隐藏*/
}
.mainbody .tableHead .box {
  padding: 24px;
  width: 29%;
  height: 50px;
  float: left;
  text-align: center;
}
.mainbody .tableHead .title1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
}
.mainbody .tableHead .title2 {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 32px;
  color: #000000;
}
.mainbody .tableHead .title3 {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  color: #000000;
}
.mainbody .tableHead .aLine {
  float: left;
  background-color: #e9e9e9;
  width: 1px;
  height: 56px;
  margin-top: 25px;
}
.mainbody .tableInfo {
  background-color: #ffffff;
  box-sizing: border-box;
  // margin-top: 24px;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 32px;
  overflow: hidden; /*溢出的部分隐藏*/
}
</style>


// WEBPACK FOOTER //
// src/components/integral/alumniList.vue